import { render } from "./CreatePeriod.vue?vue&type=template&id=7ab6fd55&scoped=true&ts=true"
import script from "./CreatePeriod.vue?vue&type=script&lang=ts"
export * from "./CreatePeriod.vue?vue&type=script&lang=ts"

import "./CreatePeriod.vue?vue&type=style&index=0&id=7ab6fd55&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ab6fd55"]])

export default __exports__